import * as Yup from 'yup';
import { buildNewPasswordRule } from '@/shared/utils';

/**
 * Validation for the self-service password change. `newPassword` derives its length and character-class
 * rules from the shared policy via {@link buildNewPasswordRule} (per `password-policy-validation`), so
 * the client never drifts from the backend policy. The current password is required as proof of
 * identity; the confirmation must match the new password.
 */
export const validationSchema = Yup.object({
  oldPassword: Yup.string().required('Current password is required'),
  newPassword: buildNewPasswordRule(),
  confirmPassword: Yup.string()
    .required('Confirm password is required')
    .oneOf([Yup.ref('newPassword')], 'Passwords must match'),
});
